angular.module("galilai.creator").controller("PostgenVideoController", function ($scope, api, $timeout, $rootScope, transcribeService, fontsService) {
    // Cost of one generated cover, when the user asks for one before the video
    const CREDITS_PER_COVER = 10;
    // The generation service has no 4:5, and without an input image there is no ratio to
    // inherit — so this flow is portrait only. A 4:5 video still comes from animating an
    // existing 4:5 post in the editor.
    const ASPECT = "9:16";

    // Mirrors services/postgen/videoModes.js. Labels live in i18n, keyed by mode id.
    const MODES = [
        { id: "lookalike", icon: "mdi-account", image: "required", featured: true, coverStep: true },
        { id: "scratch", icon: "mdi-plus", image: "optional", allowsBrandedCover: true },
        { id: "animate", icon: "mdi-image-outline", image: "required" },
        { id: "promote", icon: "mdi-tag-outline", image: "optional" },
    ];

    const BASE_STATE = {
        mode: null,
        duration: 10,
        subject: "",
        medias: [],
        // {title, scenes:[{time, action, speech}]} — editable, and it IS the prompt
        script: null,
        // Restrictions in the user's own words: what must never happen, what has to. Goes to
        // the script writer and to the video provider, because only the second can enforce
        // a rule about what appears on screen.
        guidelines: "",
        // The chosen lookalike: {_id, name, image, medias, voiceSource}. Only the id goes
        // to the server — it is what resolves the photo and the voice that reach the
        // provider.
        avatar: null,
        avatarMediaId: null,
        avatarVoiceOption: null,
        // Burned into the first frame. Only the modes with a cover step use it.
        cover: {
            enabled: true,
            title: "",
            font: "condensed",
            // Top and outlined: the headline stays clear of the face, and the outline
            // hides none of the photo
            position: "top",
            background: "stroke",
        },
    };
    const FONTS = ["sans", "condensed", "serif", "handwritten"];
    // Same families the server has bundled in assets/fonts, so preview and output match
    const PREVIEW_FONTS = ["Poppins:bold", "Anton", "DM Serif Display", "Kalam:bold"];
    const BASE_VIEW = {
        theme: null,
        author: null,
        credits: null,
        summaryCredits: null,
        recording: false,
        transcribing: false,
        writingScript: false,
        // The script is written for a duration: changing it makes the scenes wrong
        scriptStale: false,
        // The user wrote the script themselves, so the screen owes them a warning rather
        // than a suggestion
        ownScript: false,
    };

    $scope.modes = MODES;
    $scope.pallete = [];
    // 'modes' = the mode list, 'form' = the chosen mode's form
    $scope.step = "modes";
    $scope.loading = false;
    $scope.project = null;
    $scope.data = angular.copy(BASE_STATE);
    $scope.view = angular.copy(BASE_VIEW);

    function reset() {
        $scope.data = angular.copy(BASE_STATE);
        $scope.view = angular.copy(BASE_VIEW);
        $scope.step = "modes";
        $scope.project = null;
        $scope.pallete = [];
        $scope.loading = false;
    }

    // The panel colour is the darkest brand colour, mirroring what the server picks
    $scope.getCoverPanelColor = function () {
        const sorted = $scope.pallete
            .filter(function (color) {
                return /^#[0-9a-f]{6}$/i.test(color || "");
            })
            .map(function (color) {
                const r = parseInt(color.slice(1, 3), 16);
                const g = parseInt(color.slice(3, 5), 16);
                const b = parseInt(color.slice(5, 7), 16);
                return { color: color, luma: 0.299 * r + 0.587 * g + 0.114 * b };
            })
            .sort(function (a, b) {
                return a.luma - b.luma;
            });
        return sorted.length ? sorted[0].color : "#15102b";
    };

    function refreshCredits() {
        api
            .getCurrentCredits()
            .then(function (res) {
                $scope.view.credits = res.data.credits;
                $scope.view.summaryCredits = res.data;
                $timeout(angular.noop);
            })
            .catch(function (err) {
                // Ignore: the cost line degrades to hiding the balance
            });
    }

    $rootScope.$on("generator.postgenvideo.show", function (event, data) {
        reset();
        refreshCredits();

        $scope.view.theme = data.theme || null;
        $scope.view.author = data.author || null;
        $scope.project = data.project;

        // Brand colours for the cover panel, same source the post modal reads
        if ($scope.view.theme && $scope.view.theme.pallete) {
            $scope.pallete = [
                $scope.view.theme.pallete.main,
                $scope.view.theme.pallete.text,
                $scope.view.theme.pallete.highlight,
            ].filter(function (color) {
                return color;
            });
        }

        // The dashboard has a shortcut straight into one mode
        if (data.mode) {
            $scope.chooseMode(data.mode);
        }
        angular.element("#postgen-video-modal").modal("show");
    });

    $rootScope.$on("credits.refresh", function () {
        refreshCredits();
    });

    $rootScope.$on("credits.updated", function () {
        refreshCredits();
    });

    $scope.chooseMode = function (id) {
        const mode = MODES.filter(function (m) {
            return m.id === id;
        })[0];
        if (!mode) {
            return;
        }
        $scope.data.mode = mode;
        $scope.step = "form";
    };

    $scope.backToModes = function () {
        $scope.step = "modes";
        $scope.data.mode = null;
    };

    $scope.fonts = FONTS;

    $scope.hasCoverStep = function () {
        return Boolean($scope.data.mode && $scope.data.mode.coverStep);
    };

    $scope.continueToCover = function () {
        if (!$scope.canGenerate()) {
            return;
        }
        // The headline the model wrote is the natural default for the cover
        if (!$scope.data.cover.title) {
            $scope.data.cover.title = ($scope.data.script && $scope.data.script.title) || "";
        }
        // The preview draws with the same families the server has bundled, so the
        // approved look matches what gets rendered
        fontsService.load(PREVIEW_FONTS);
        $scope.step = "cover";
    };

    $scope.backToForm = function () {
        $scope.step = "form";
    };

    $scope.chooseCoverFont = function (font) {
        $scope.data.cover.font = font;
    };

    $scope.chooseCoverPosition = function (position) {
        $scope.data.cover.position = position;
    };

    $scope.chooseCoverBackground = function (background) {
        $scope.data.cover.background = background;
    };

    $scope.fontLabel = function (font, suffix) {
        return gettext("postgenvideo.font_" + font + (suffix ? "_" + suffix : ""));
    };

    $scope.backgroundLabel = function (background) {
        return gettext("postgenvideo.cover_background_" + background);
    };

    /**
     * The server fits the headline to the image width, between 44 and 120px on a 1080px
     * canvas. The browser cannot measure the bundled fonts the way opentype does, so the
     * preview approximates that curve by title length.
     *
     * The thresholds are not guesses: they come from running the server's own fitLines
     * against the four fonts. Up to ~45 characters every font hits the 120px cap, which
     * is why a short headline fills the frame in the final video.
     */
    $scope.coverSizeClass = function () {
        const length = (($scope.data.cover && $scope.data.cover.title) || "").trim().length;
        if (length <= 45) {
            return "size-xl";
        }
        if (length <= 55) {
            return "size-lg";
        }
        if (length <= 65) {
            return "size-md";
        }
        if (length <= 85) {
            return "size-sm";
        }
        return "size-xs";
    };

    $scope.chooseDuration = function (seconds) {
        if ($scope.data.duration === seconds) {
            return;
        }
        $scope.data.duration = seconds;
        // The scenes were timed for the old duration, so they no longer add up
        $scope.view.scriptStale = Boolean($scope.data.script);
    };

    $scope.hasScript = function () {
        return Boolean($scope.data.script && $scope.data.script.scenes && $scope.data.script.scenes.length);
    };

    $scope.canWriteScript = function () {
        if ($scope.view.writingScript || !$scope.data.mode) {
            return false;
        }
        return Boolean(($scope.data.subject || "").trim());
    };

    $scope.writeScript = function () {
        if (!$scope.canWriteScript()) {
            return;
        }
        $scope.view.writingScript = true;

        api
            .generateVideoScript({
                mode: $scope.data.mode.id,
                subject: $scope.data.subject,
                duration: $scope.data.duration,
                guidelines: $scope.data.guidelines,
                // The script has to come out in the project's language, not the device's
                project: $scope.project,
            })
            .then(function (res) {
                if (res?.data?.success && res.data.script) {
                    $scope.data.script = res.data.script;
                    $scope.view.scriptStale = false;
                    $scope.view.ownScript = false;
                    return;
                }
                showError(gettext("postgenvideo.script_error"));
            })
            .catch(function (err) {
                showError(gettext("postgenvideo.script_error"));
            })
            .finally(function () {
                $scope.view.writingScript = false;
                $timeout(angular.noop);
            });
    };

    /**
     * An empty script, timed for the chosen duration, for whoever already knows what the
     * video says.
     *
     * The scene count and the boundaries mirror the server (videoScript.sceneCountFor): one
     * scene per ~4 seconds, floor of one below five seconds, so a hand-written script is
     * divided exactly like a generated one and the provider sees no difference.
     */
    function emptyScript(duration) {
        const seconds = parseInt(duration, 10) || 10;
        const floor = seconds < 5 ? 1 : 2;
        const count = Math.max(floor, Math.min(6, Math.round(seconds / 4)));
        const scenes = [];
        for (let i = 0; i < count; i++) {
            const from = Math.round((seconds * i) / count);
            const to = Math.round((seconds * (i + 1)) / count);
            scenes.push({ time: from + "-" + to + "s", action: "", speech: "" });
        }
        return { title: "", scenes: scenes };
    }

    $scope.hasOwnScript = function () {
        return Boolean($scope.view.ownScript);
    };

    // Deliberately a plain link, not a second button: it is the path for the few who arrive
    // with the words already written, and it asks more of them than the generated one.
    $scope.useOwnScript = function () {
        $scope.data.script = emptyScript($scope.data.duration);
        $scope.view.ownScript = true;
        $scope.view.scriptStale = false;
    };

    $scope.modeLabel = function (mode, suffix) {
        return gettext("postgenvideo.mode_" + mode.id + (suffix ? "_" + suffix : ""));
    };

    $scope.addImage = function () {
        $rootScope.$broadcast("media.show", {
            source: {
                origin: "postgenvideo.create",
            },
            projectId: $scope.project,
            kind: "image",
            openModal: true,
            multiple: false,
        });
    };

    $scope.removeImage = function () {
        $scope.data.medias = [];
    };

    $rootScope.$on("media.selected", function (event, medias, source) {
        if (!source || source.origin != "postgenvideo.create") {
            return;
        }
        if (!medias || !medias.length) {
            return;
        }
        // One image only: it becomes the first frame, so a second one has nowhere to go
        $scope.data.medias = [{ url: medias[0].url }];
        $timeout(angular.noop);
    });

    // The lookalike keeps photo and voice and is reused on every video — instead of
    // uploading both again
    $scope.chooseAvatar = function () {
        $rootScope.$broadcast('avatar.picker.show', {
            origin: 'postgenvideo',
            projectId: $scope.project,
        });
    };

    $scope.hasAvatar = function () {
        return Boolean($scope.data.avatar && $scope.data.avatar.image);
    };

    $scope.hasMultiplePhotos = function () {
        return Boolean($scope.data.avatar && $scope.data.avatar.medias && $scope.data.avatar.medias.length > 1);
    };

    // Same lookalike, another face: cycles through its photos instead of opening the
    // picker again. With a single photo there is nothing to cycle — then what the user
    // wants is to add more.
    $scope.nextAvatarPhoto = function () {
        if (!$scope.hasAvatar()) {
            return;
        }
        if (!$scope.hasMultiplePhotos()) {
            $rootScope.$broadcast('avatar.picker.show', {
                origin: 'postgenvideo',
                projectId: $scope.project,
                editAvatarId: $scope.data.avatar._id,
            });
            return;
        }
        const photos = $scope.data.avatar.medias;
        const current = photos.findIndex(function (photo) {
            return photo.url === $scope.data.avatar.image;
        });
        const next = photos[(current + 1) % photos.length];
        $scope.data.avatar.image = next.url;
        $scope.data.avatarMediaId = next.mediaId;
    };

    $rootScope.$on("avatar.selected", function (event, data) {
        if (!data || data.origin !== "postgenvideo" || !data.avatar) {
            return;
        }
        $scope.data.avatar = data.avatar;
        $scope.data.avatarMediaId = null;
        $scope.data.avatarVoiceOption = data.voiceOption || null;
        $timeout(angular.noop);
    });

    $scope.hasImage = function () {
        return Boolean($scope.data.medias && $scope.data.medias.length);
    };

    // The cover preview draws over the photo that becomes the first frame — which in the
    // lookalike modes is its photo, not an upload
    $scope.getImageURL = function () {
        if ($scope.hasAvatar()) {
            return $scope.data.avatar.image;
        }
        return $scope.hasImage() ? $scope.data.medias[0].url : null;
    };

    // The branded-cover path only exists for the mode that allows it, and only while
    // there is no image: with an image there is nothing left to design.
    $scope.canGenerateBrandedCover = function () {
        return Boolean($scope.data.mode && $scope.data.mode.allowsBrandedCover) && !$scope.hasImage();
    };

    // The script is the prompt, so there is nothing to generate without one
    $scope.canGenerate = function () {
        if ($scope.loading || !$scope.data.mode) {
            return false;
        }
        // In the modes with a person on screen, the lookalike plays the image's part
        if ($scope.hasCoverStep() && !$scope.hasAvatar()) {
            return false;
        }
        if (!$scope.hasCoverStep() && $scope.data.mode.image === "required" && !$scope.hasImage()) {
            return false;
        }
        // The balance is known here, so the refusal belongs here and not in a round trip
        // that comes back only to open the paywall without saying what would have fit
        if (!$scope.canAffordDuration($scope.data.duration)) {
            return false;
        }
        return $scope.hasScript();
    };

    // The cover is a design brief, not a script: the subject is enough. The video is
    // confirmed later, from the editor, once the user approves what was designed.
    $scope.canGenerateCover = function () {
        return !$scope.loading && Boolean(($scope.data.subject || "").trim());
    };

    $scope.getVideoCredits = function () {
        return $rootScope.getVideoCreditsFor($scope.data.duration || 10);
    };

    $scope.canAffordDuration = function (duration) {
        return $rootScope.canAffordVideoDuration(duration, $scope.view.credits);
    };

    // Empty while the chosen duration fits, so the template can use it as the condition
    $scope.getDurationWarning = function () {
        return $rootScope.getVideoCreditsWarning($scope.data.duration, $scope.view.credits);
    };

    $scope.getCreditsMessage = function () {
        // The branded-cover path only charges the cover now; the video is confirmed later
        let part1;
        if ($scope.canGenerateBrandedCover()) {
            part1 = gettext("postgen.credits_used_cover")
                .replace("%s", "<strong>" + CREDITS_PER_COVER + "</strong>")
                .replace("%s", "<strong>" + $scope.getVideoCredits() + "</strong>");
        } else {
            part1 = gettext("postgen.credits_used").replace(
                "%s",
                "<strong>" + $scope.getVideoCredits() + "</strong>"
            );
        }

        let part2 = "";
        if (typeof $scope.view.credits == "number") {
            part2 = gettext("postgen.credits_owned").replace(
                "%s",
                "<strong>" + $scope.view.credits + "</strong>"
            );
        }
        return part1 + ". " + part2;
    };

    const recorder = transcribeService.createRecorder({
        onText: function (text) {
            $scope.data.subject = text;
        },
        onState: function (state) {
            $scope.view.recording = state.recording;
            $scope.view.transcribing = state.transcribing;
        },
    });

    $scope.transcribe = function () {
        recorder.toggle();
    };

    $scope.stopTranscription = function () {
        recorder.stop();
    };

    // A readable fallback for inputs.prompt, which the schema requires. The prompt the
    // provider actually receives is rebuilt server-side from the structured script.
    function scriptAsPrompt() {
        if (!$scope.hasScript()) {
            return $scope.data.subject;
        }
        return $scope.data.script.scenes
            .map(function (scene) {
                return scene.action;
            })
            .join(" ");
    }

    /**
     * brandedCover = generate the cover with the user's identity first and let them
     * approve it before spending the video credits (the existing image flow).
     */
    $scope.generate = function (brandedCover) {
        if (brandedCover ? !$scope.canGenerateCover() : !$scope.canGenerate()) {
            return;
        }
        $scope.loading = true;

        const inputs = {
            format: "video",
            aspect: ASPECT,
            duration: $scope.data.duration,
            videoMode: $scope.data.mode.id,
            project: $scope.project,
            startingPoint: brandedCover ? "scratch" : "upload",
            // The branded cover is a design brief, so it gets the subject. The video
            // itself is driven by the script.
            prompt: brandedCover ? $scope.data.subject : scriptAsPrompt(),
            script: brandedCover ? null : $scope.data.script,
            // Reaches the provider as well as the script writer: "never show my hands" is a
            // rule about the video, and the writer cannot enforce it
            guidelines: $scope.data.guidelines || null,
            pallete: $scope.pallete.length ? $scope.pallete : null,
        };
        if (!brandedCover && $scope.hasAvatar() && $scope.hasCoverStep()) {
            inputs.avatarId = $scope.data.avatar._id;
            inputs.avatarMediaId = $scope.data.avatarMediaId;
            inputs.avatarVoiceOption = $scope.data.avatarVoiceOption;
        }
        if (!brandedCover && $scope.hasCoverStep()) {
            inputs.cover = $scope.data.cover;
        }
        const medias = $scope.data.medias || [];
        if (!brandedCover) {
            inputs.medias = medias;
        }

        api
            .createPostContent({
                project: $scope.project,
                inputs: inputs,
                items: [
                    Object.assign({}, inputs, {
                        prompt: $scope.data.subject,
                        medias: brandedCover ? [] : medias,
                    }),
                ],
            })
            .then(function (res) {
                if (res?.data?.success) {
                    $rootScope.$emit("postgen.edit", {
                        postId: res.data.postContent.postId,
                        isNew: true,
                    });
                    angular.element("#postgen-video-modal").modal("hide");
                    return;
                }
                if (res?.data?.error === "no_credits") {
                    $rootScope.$emit("credits.show");
                    return;
                }
                if (res?.data?.error === "plan_required") {
                    angular.element("#postgen-video-modal").modal("hide");
                    $rootScope.showUpgrade("video_generation");
                    return;
                }
                showError(gettext("error.generic"));
            })
            .catch(function (err) {
                showError(gettext("error.generic"));
            })
            .finally(function () {
                $scope.loading = false;
                $timeout(angular.noop);
            });
    };

    $scope.purchaseCredits = function () {
        $rootScope.$emit("credits.show");
    };
});
